import React from 'react';
import styled from 'styled-components';
import {ReactComponent as IconoFlecha} from './../imagenes/refrescar.svg';
import {useNavigate} from 'react-router-dom';
import { Link } from "react-router-dom";

const Contenedor = styled.div`
    display: grid;
    height: 100%;
    width: 100%;
    grid-template-columns: 0.01fr 8fr;

`;

const Controles = styled.div`
    width: 100%;
    height: 100%;
    padding: 1rem;
    background: #fff;
    color : #fff
`;

const ContenedorMapa = styled.div`
    width: 100%
    heigth: 100%;
`;
const BotonsRecarga = styled(Link)`
display: block;
width: 3.12rem; /* 50px */
height: 3.12rem; /* 50px */
line-height: 3.12rem; /* 50px */
text-align: center;
margin-right: 1.25rem; /* 20px */
border: none;
background: #001089;
color: #fff;
display: flex;
align-items: center;
justify-content: center;
border-radius: 0.31rem; /* 5px */
cursor: pointer;

@media(max-width: 60rem){ /* 950px */
    width: 2.5rem; /* 40px */
    height: 2.5rem; /* 40px */
    line-height: 2.5rem; /* 40px */
}

`;
const Icono = styled(IconoFlecha)`
    width: 50%;
    height: auto;
    fill: #fff;
`;
export {
  Contenedor,
  Controles,
  ContenedorMapa,
  BotonsRecarga,
  Icono
};